/**
 * UtilityBar — DEPRECATED.
 *
 * The top utility bar (phone, email, language, socials) was removed from
 * the design; language now lives in the Navbar dropdown. Kept as a no-op
 * so the existing `<UtilityBar />` references in pages still resolve.
 * Safe to delete this file and its imports once those references are gone.
 */
export default function UtilityBar() {
  return null;
}
